// 9fbef606107a605d69c0edbcd8029e5d
const names = {
  eVarPropEvent: {
    event52: 'Wishlist_Add_Product_e52',
    event94: 'Added_to_Wishlist_e94',
    event50: 'Cross_Sell_Clicks_e50',
    eVar20: 'Cross_Sell_Referring_Product_v20',
    eVar21: 'Cross_Sell_Location_v21',
    eVar19: 'Internal_Campaigns_v19',
    prop21: 'Navigation_Pathing_p21',
    eVar22: 'Prod_Finding_Method_v22',
    eVar151: 'Footer_Tab_Name_V151',
    event154: 'getCandidAddToBag_e154',
    event155: 'onboarding_skips_e155',
    Refinement_Used_v50: 'Refinement_Used_v50',
    Sort_Options_v51: 'Sort_Options_v51',
    event169: 'App_Use_My_Location_e169',
    event170: 'App_Search_Store_Using_Zip_e170',
  },
  screenNames: {
    mpr_login: 'MPR_LOG_IN_CLICKS_e110',
    create_acc_plcc: 'CREATE_ACCOUNT_CLICKS_e111',
    manage_plcc: 'manageCreditAccount_e113',
    plccCheckout: 'PLCC_CONTINUE_TO_CHECKOUT_e114',
    plccShopping: 'PLCC_CONTINUE_SHOPPING_e115',
    plcc_apply_now: 'PLCC_APPLY_NOW_CLICKS_e116',
    plcc_learn_more: 'PLCC_LEARN_MORE_CLICKS_e117',
    plcc_success: 'PLCC_Application_Submitted_e49',
    create_wishlist: 'Wishlist_Creations_e64',
    delete_wishlist: 'Wishlist_Deletions_e54',
    remove_from_wishlist: 'Wishlist_Remove_Product_e53',
    product_listing: 'productListingPageViews_e91',
    store_details: 'storePageViews_e96',
    search_store_null: 'nullStoreSearchResults',
    search_store: 'storeSearches_e89',
    getCandid150: 'getCandidImageClick_e150',
    getCandid151: 'getCandidSeeMore_e151',
    getCandid152: 'getCandidOnLoadDetailView_e152',
    get_store_directions: 'storeGetDirectionsClicks_e97',
    set_store_fav: 'storeSelected_e67',
    shopping: 'ONBoarding_Start_Shopping_Clicks_E156',
    continueAsGuest: 'ONBoarding_ContinueAsGuest_Clicks',
    login: 'ONBoarding_Login_Clicks_E155',
    join: 'ONBoarding_Join_Clicks_E154',
    maybe_later: 'ONBoarding_MayBeLater_Clicks_E157',
    onboarding_end: 'ONBoarding_Complete',
    onboarding_start: 'ONBoarding_Start',
    notification_click: 'ONBoarding_Notification_Clicks_E159',
    location_access: 'ONBoarding_LocationAccess_Clicks',
    register_success: 'siteRegistration_e13',
    login_success: 'Logins_e14',
    order_tracking: 'orderTrackingClick_e118',
    birthday_signup: 'birthdayClubSign_ups_e16',
    birthday_success: 'birthdayClubSuccess_e16',
    footer_tab: 'Footer_Tab_Clicks_E158',
    navigation_l1: 'navigation_l1',
    navigation_click: 'Click_Navigation_v97',
    pickup_store_search105: 'Product_Availability_Checks_e105',
    pickup_store_search106: 'Product_Availability_Success_e106',
    pickup_store: 'Pick_Up_In_Store_e131',
    sbp_create_profile: 'SBP_Create_Profile_e23',
    sbp_finish_profile: 'SBP_Finish_Profile_e24',
    sbp_gender: 'SBP_Gender_v54',
    sbp_incomplete_profile: 'SBP_Incomplete_Profile',
    sbp_welcome_back_profile: 'SBP_Welcome_Back_Profile_e25',
    sbp_profiles: 'SBP_Profiles',
    sbp_size_drop_down_click_pdp: 'SBP_Size_Click_Pdp_e28',
    sbp_top_categories_plp: 'SBP_Top_Categories_Plp_e30',
    sbp_top_matches_plp: 'SBP_Top_Matches_Plp_e29',
    applePay_e148: 'applePay148',
    chatBot_launch_e123: 'chatbot_e123',
    order_recommendation_drawer_close: 'recom_drawer_close_e126',
    order_recommendation_drawer_open: 'recom_drawer_open_e125',
    atb_drawer_view_bag: 'atb_drawer_view_bag_e143',
    atb_drawer_keep_shopping: 'atb_drawer_keep_shopping_e144',
    loyalty_join_click: 'Loyalty_Create_Account_Clicks_e125',
    loyalty_login_click: 'Loyalty_Login_Clicks_e126',
    loyalty_join_success: 'Loyalty_Create_Account_Success_e127',
    loyalty_login_success: 'Loyalty_Login_Success_e128',
    loyalty_apply_now_click: 'Loyalty_Apply_Now_Click_e129',
    loyalty_learn_more_click: 'Loyalty_Learn_More_e130',
    loyalty_apply_or_accept_offer_click: 'Loyalty_Apply_Or_Accept_Offer_e131',
    loyalty_plcc_submit_success: 'Loyalty_PLCC_Submit_e132',
    loyalty_plcc_no_thanks_click: 'Loyalty_PLCC_No_Thanks_e133',
    loyalty_mpr_image_click: 'Loyalty_MPR_Image_Click_e134',
    loyalty_plcc_image_click: 'Loyalty_PLCC_Image_Click_e135',
    loyalty_join_club_birthday: 'Loyalty_Join_Club_Birthday_e136',
    loyalty_continue_as_guest: 'Loyalty_Continue_As_Guest_e137',
    plcc: 'plcc_form',
    gcb: 'gift_card_balance_form',
    skip_click_onboarding: 'OnBoarding_Skips_p155',
    learn_more_plcc_banner_click_pdp: 'Learn_More_PLCC_Banner_Pdp_e134',
    Sort_filter_clicks_e161: 'Sort_filter_clicks_e161',
    navigation_clicks_e82: 'navigation_clicks_e82',
    shop_by_department_impression: 'shop_by_department_impression',
    shop_by_department_click: 'shop_by_department_click',
    trending_in_your_area_clicks: 'trending_in_your_area_clicks',
  },
};

export default names;
